import React from 'react';
import { Tag } from 'antd';
import dayjs from 'dayjs';

import { getCustomerStatus } from '../../utils/CodeMapper';
import { getDisplayName } from '../../utils/getDisplayName';
import { sortByDate, sortByText } from '../../utils/tableSorters';

export const CUSTOMER_TABLE_SCROLL_X = 1240;
export const CUSTOMER_PHONE_MAX_LENGTH = 14;
export const CUSTOMER_ADDRESS_MAX_LENGTH = 32;

const truncateText = (value, maxLength) => {
  const text = String(value ?? '').trim();

  if (!text) {
    return '-';
  }

  return text.length > maxLength ? `${text.slice(0, maxLength)}..` : text;
};

export const formatCustomerPhone = (value) =>
  truncateText(value, CUSTOMER_PHONE_MAX_LENGTH);

export const getCustomerAddress = (record) =>
  `${record?.address || ''} ${record?.addressDetail || ''}`.trim();

export const formatCustomerAddress = (record) =>
  truncateText(getCustomerAddress(record), CUSTOMER_ADDRESS_MAX_LENGTH);

export const buildCustomerColumns = () => [
  {
    title: '고객사명',
    key: 'name',
    dataIndex: 'name',
    width: 180,
    sorter: sortByText((record) => record.name),
  },
  {
    title: '대표 연락처',
    key: 'tel',
    dataIndex: 'tel',
    width: 140,
    ellipsis: true,
    sorter: sortByText((record) => record.tel),
    render: (value) => formatCustomerPhone(value),
  },
  {
    title: '주소',
    key: 'address',
    width: 300,
    ellipsis: true,
    sorter: sortByText((record) => getCustomerAddress(record)),
    render: (_, record) => formatCustomerAddress(record),
  },
  {
    title: '상태',
    key: 'status',
    dataIndex: 'status',
    width: 80,
    align: 'center',
    sorter: sortByText((record) => getCustomerStatus(record.status)),
    render: (value) => <Tag>{getCustomerStatus(value)}</Tag>,
  },
  {
    title: '등록일시',
    key: 'createdAt',
    dataIndex: 'createdAt',
    width: 170,
    align: 'center',
    sorter: sortByDate((record) => record.createdAt),
    render: (_, record) => dayjs(record.createdAt).format('YYYY-MM-DD HH:mm:ss'),
  },
  {
    title: '등록자',
    key: 'createdBy',
    dataIndex: 'createdBy',
    width: 100,
    align: 'center',
    sorter: sortByText((record) => getDisplayName(record.createdBy)),
    render: (_, record) => getDisplayName(record.createdBy),
  },
  {
    title: '수정일시',
    key: 'updatedAt',
    dataIndex: 'updatedAt',
    width: 170,
    align: 'center',
    sorter: sortByDate((record) => record.updatedAt),
    render: (_, record) => dayjs(record.updatedAt).format('YYYY-MM-DD HH:mm:ss'),
  },
  {
    title: '수정자',
    key: 'updatedBy',
    dataIndex: 'updatedBy',
    width: 100,
    align: 'center',
    sorter: sortByText((record) => getDisplayName(record.updatedBy)),
    render: (_, record) => getDisplayName(record.updatedBy),
  },
];
